import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles(({

}))

export default ({data}) => {
  const classes = useStyles();

  if (data.isHTML) {
    return <Container>
      <div dangerouslySetInnerHTML={{__html: data.content}} />
    </Container>
  }
  else {
    return <Container>
      {data.content.split(/\r?\n/).map((line, idx) => {
        return <p key={idx}>{line}</p>
      })}
    </Container>
  }
}